import { TableUtils } from "../../../../../../utils";
import { IEditableListRowState } from "../../types";
import { IAvisEditableListRowClassProps } from "../AvisEditableListRowClass";
import { AvisEditableListRowField } from "../AvisEditableListRowField";
import { AvisEditableListRowActions } from "../actions/AvisEditableListRowActions";

interface IAvisEditableListTableRowProps<P extends IEditableListRowState>
  extends IAvisEditableListRowClassProps<P> {
  rowClass: string;
}
export function AvisEditableListTableRow<P extends IEditableListRowState>(
  props: Readonly<IAvisEditableListTableRowProps<P>>,
): JSX.Element {
  const { disabled, rowClass, onStateChange } = props;

  return (
    <tr className={rowClass}>
      {!disabled && (
        <td>
          <AvisEditableListRowActions<P>
            {...props}
            onStateChange={onStateChange}
          />
        </td>
      )}
      {props.fields.map((f) => (
        <td
          key={f.name.toString()}
          style={{
            minWidth: TableUtils.convertWidth(f.minWidth),
            maxWidth: TableUtils.convertWidth(f.maxWidth),
            width: TableUtils.convertWidth(f.width),
          }}
        >
          <AvisEditableListRowField<P>
            {...props}
            key={f.name.toString()}
            field={f}
            rowIndex={props.index}
          />
        </td>
      ))}
    </tr>
  );
}
